/**
 * Available tracking events for pages.
 */
export enum AnalyticsPageEvents {
  Visited = 'Visited',
}
